module.exports = __webpack_public_path__ + "img/meta_lg.a08fb2a2.png";